import { NOTFOUND } from '../../constant';
import type { AppRouteRecordRaw } from '/@/router/types';

export const rootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: '/index',
  meta: {
    title: '',
  },
};

/**
 * 异常页面
 */
export const notFoundRoute: AppRouteRecordRaw = {
  path: '/404',
  name: NOTFOUND,
  component: () => import('/@/views/basic/404/index.vue'),
  meta: {
    title: '404页面',
    hideMenu: true,
  },
};

/**
 * 异常页面
 */
export const exceptionRoute: AppRouteRecordRaw = {
  path: '/:path(.*)*',
  name: 'Exception',
  component: () => import('/@/views/basic/exception/index.vue'),
  meta: {
    title: '错误页面',
    hideTools: true,
  },
};
